import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { InformationPopoverComponent } from '../popovers/information-popover/information-popover.component';
import { UnfocusElementService } from './unfocus-element.service';

@Injectable({
    providedIn: 'root'
})
export class PopoverService {

    constructor(
        private unfocusService: UnfocusElementService,
        private popoverController: PopoverController
    ) { }


    async getInfoPopover(event, title, content) {
        this.unfocusService.unfocus(event);
        const popover = await this.popoverController.create({
            component: InformationPopoverComponent,
            componentProps: {
                "titleContent": title,
                "infoContent": content
            },
            cssClass: 'information-popover',
            event: event,
            translucent: true,
            showBackdrop: false,
            animated: false
        });
        return popover;
    }
}